import { render, staticRenderFns } from "./WorkflowTask.vue?vue&type=template&id=06270fb6"
import script from "./WorkflowTask.vue?vue&type=script&lang=js"
export * from "./WorkflowTask.vue?vue&type=script&lang=js"
import style0 from "./WorkflowTask.vue?vue&type=style&index=0&id=06270fb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports